module.exports = __webpack_public_path__ + "img/hic-cancer-female.38189a7e.png";